module.exports = __webpack_public_path__ + "static/img/14010011.791715f5.png";